import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodTransferTransaction  {
    _originalTypeClassName = "zERP.BO.GoodTransferTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodTransferTransaction.translate = translateService;
}
this.Transfers = [];
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Type = null;
this.DateCreated = null;
this.Finalized = false;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Type:any;
DateCreated:any;
Finalized:any;
Description:any;
Transfers:any;
FiscalYear:any;
Entity:any;
Invoice:any;
PhysicalInventory:any;
static setTransfers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transfers == null) $this.Transfers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transfers.length > 0) {
                    Domain.GoodTransferTransaction.removeTransfers($this, $this.Transfers[0]);
                }

                Domain.GoodTransferTransaction.addManyTransfers($this, copyItems);
            }
static addManyTransfers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodTransferTransaction.addTransfers($this, items[i]);
                }
            }
static addTransfers = ($this, item) => {
                if ($this.Transfers == null) $this.Transfers = [];
                if (item == null || $this.Transfers.indexOf(item) > -1) return;
                $this.Transfers.push(item);
if (item.GoodTransferTransaction != $this) {
Domain.GoodTransfer.setGoodTransferTransaction(item, $this);
}
}
static addRangeTransfers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodTransferTransaction.addTransfers($this, item));
            }
static removeTransfers = ($this, item) => {
                if ($this == null || $this.Transfers == null || $this.Transfers.indexOf(item) === -1) return;
                var _index = $this.Transfers.indexOf(item);
                $this.Transfers.splice(_index, 1);
item.GoodTransferTransaction = null;
}
static clearTransfers = ($this) => { $this.Transfers = null; }
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setPhysicalInventory = ($this, value) => {
var oldValue = $this.PhysicalInventory;
$this.PhysicalInventory = value;
if (value != null) {
if (oldValue != null && oldValue.GoodTransferTransaction != null) { oldValue.GoodTransferTransaction = null; }
if ($this.PhysicalInventory.GoodTransferTransaction !== $this) {
Domain.GoodPhysicalInventory.setGoodTransferTransaction(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}